import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import { EventInitVariables } from '../email-template/event.interface';

export interface ViberModel extends BaseModel {
  variables?: { [key: string]: string } | ViberVariables;
}

export interface ViberVariables {
  text: string;
  image_url: string;
  cta_text: string;
  cta_link: string;
}

export class ViberInitVariables implements ViberVariables {
  text = '';
  image_url = '';
  cta_text = '';
  cta_link = '';
}

export class ViberInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new ViberInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
